import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Renders children only for admins whose role is in `roles`; others go to the dashboard.
const RoleRoute = ({ roles, children }) => {
  const { auth } = useAuth();
  if (!roles.includes(auth?.admin?.role)) return <Navigate to="/" replace />;
  return children;
};

export default RoleRoute;
